var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipmentsCompletedReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.2862 0.66785C6.47594 0.455061 6.74748 0.333374 7.03257 0.333374H15.6175C15.9026 0.333374 16.1741 0.455061 16.3639 0.66785L21.7295 6.68529C21.8928 6.86848 21.9831 7.10536 21.9831 7.35081V11.5457C21.9831 12.098 21.5354 12.5457 20.9831 12.5457C20.4308 12.5457 19.9831 12.098 19.9831 11.5457V8.35081H2.66699V21.3744H9.43489C9.98718 21.3744 10.4349 21.8222 10.4349 22.3744C10.4349 22.9267 9.98718 23.3744 9.43489 23.3744H1.66699C1.11471 23.3744 0.666992 22.9267 0.666992 22.3744V7.35081C0.666992 7.10536 0.757263 6.86848 0.920615 6.68529L6.2862 0.66785ZM3.89847 6.35081H10.325V2.33337H7.48071L3.89847 6.35081ZM12.325 2.33337V6.35081H18.7516L15.1694 2.33337H12.325Z",
    fill: "#FF5F14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7883 28.6667C24.3038 28.6667 27.1537 25.8168 27.1537 22.3012C27.1537 18.7857 24.3038 15.9358 20.7883 15.9358C17.2728 15.9358 14.4229 18.7857 14.4229 22.3012C14.4229 25.8168 17.2728 28.6667 20.7883 28.6667ZM20.7883 30.6667C25.4084 30.6667 29.1537 26.9213 29.1537 22.3012C29.1537 17.6811 25.4084 13.9358 20.7883 13.9358C16.1682 13.9358 12.4229 17.6811 12.4229 22.3012C12.4229 26.9213 16.1682 30.6667 20.7883 30.6667Z",
    fill: "#FF5F14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentsCompletedReport);
export default __webpack_public_path__ + "static/media/ShipmentsCompletedReport.9039292c7e4cacb0b7f8008ef4c85a1d.svg";
export { ForwardRef as ReactComponent };